var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 5.9987C11.8333 8.5787 9.59325 10.6654 6.83325 10.6654L6.21326 11.412L5.84659 11.8521C5.53325 12.2254 4.93325 12.1454 4.72658 11.6987L3.83325 9.73202C2.61992 8.87868 1.83325 7.52536 1.83325 5.9987C1.83325 3.4187 4.07325 1.33203 6.83325 1.33203C8.84659 1.33203 10.5866 2.44537 11.3666 4.04537C11.6666 4.6387 11.8333 5.2987 11.8333 5.9987Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 8.57353C15.1667 10.1002 14.38 11.4536 13.1667 12.3069L12.2734 14.2735C12.0667 14.7202 11.4667 14.8069 11.1534 14.4269L10.1667 13.2402C8.55337 13.2402 7.11338 12.5269 6.21338 11.4135L6.83337 10.6669C9.59337 10.6669 11.8334 8.5802 11.8334 6.0002C11.8334 5.3002 11.6667 4.64021 11.3667 4.04688C13.5467 4.54688 15.1667 6.38686 15.1667 8.57353Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16675 6H8.50008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.a220ac1eccaafcae7399b288740c7987.svg";
export { ForwardRef as ReactComponent };